import { DESIGN_PREVIEW, previewGetAiConsent, previewSetAiConsent } from './designPreview';
import { apiFetch } from './apiClient';
import { getAuthToken } from './supabaseClient';

export type AiConsentState = {
  granted: boolean;
  consentVersion: string | null;
  grantedAt: string | null;
  revokedAt: string | null;
};

export async function getAiConsent(): Promise<AiConsentState> {
  if (DESIGN_PREVIEW) {
    return previewGetAiConsent();
  }
  const token = await getAuthToken();
  if (!token) {
    throw new Error('Not signed in');
  }
  return apiFetch<AiConsentState>('/api/ai-consent', { token });
}

export async function setAiConsent(granted: boolean): Promise<AiConsentState> {
  if (DESIGN_PREVIEW) {
    return previewSetAiConsent(granted);
  }
  const token = await getAuthToken();
  if (!token) {
    throw new Error('Not signed in');
  }
  return apiFetch<AiConsentState>('/api/ai-consent', {
    method: 'PATCH',
    token,
    body: { granted },
  });
}
